'use client';

import styles from './News.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import Mobile from './Mobile/Mobile';
import Desktop from './Desktop/Desktop';
import { useEffect, useState, memo } from 'react';
import Loader from '../../ui/Loader/Loader';

const News = memo(function News({ newsList, readText, newsButtonDefault, newsButtonOpposite }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const processNewsData = () => {
      try {
        // 如果从首页传递了 newsList 数据，使用它
        if (newsList && newsList.length > 0) {
          const rawNewsList = newsList?.value || newsList || [];
          const transformedArticles = rawNewsList.map((newsItem) => {
            // 统一数据结构，与News页面保持一致
            const detail = newsItem?.fields?.detail?.fields || newsItem?.detail?.fields || {};

            // 构建与News页面一致的数据结构
            return {
              id: newsItem.id || detail.id,
              title: detail?.title?.value || newsItem?.title?.value || newsItem?.title || '',
              subtitle:
                detail?.subtitle?.value || newsItem?.subtitle?.value || newsItem?.subtitle || '',
              date: detail?.date?.value || newsItem?.date?.value || newsItem?.date || '',
              imageUrl:
                detail?.image?.value?.src ||
                detail?.image?.url?.src ||
                newsItem?.image?.value?.src ||
                newsItem?.image?.url ||
                '',
              // 统一跳转逻辑：优先使用url字段，与News页面保持一致
              url: newsItem?.url || detail?.url?.value || newsItem?.link?.value || '',
              category: detail?.category?.value || newsItem?.category?.value || '',
              content: detail?.content?.value || newsItem?.content?.value || '',
              // 保持fields结构，与News页面一致
              fields: {
                detail: {
                  fields: {
                    title: {
                      value:
                        detail?.title?.value || newsItem?.title?.value || newsItem?.title || '',
                    },
                    subtitle: {
                      value:
                        detail?.subtitle?.value ||
                        newsItem?.subtitle?.value ||
                        newsItem?.subtitle ||
                        '',
                    },
                    date: {
                      value: detail?.date?.value || newsItem?.date?.value || newsItem?.date || '',
                    },
                    image: {
                      value: {
                        src:
                          detail?.image?.value?.src ||
                          detail?.image?.url?.src ||
                          newsItem?.image?.value?.src ||
                          newsItem?.image?.url ||
                          '',
                      },
                    },
                    url: {
                      value: newsItem?.url || detail?.url?.value || newsItem?.link?.value || '',
                    },
                    category: { value: detail?.category?.value || newsItem?.category?.value || '' },
                  },
                },
              },
            };
          });

          setArticles(transformedArticles);
        }
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    processNewsData();
  }, [newsList]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    // return <p>Error: {error}</p>;
    return <></>;
  }

  return (
    <div className={styles.news}>
      <Desktop articles={articles} readText={readText} />
      <Mobile
        articles={articles}
        readText={readText}
        newsButtonDefault={newsButtonDefault}
        newsButtonOpposite={newsButtonOpposite}
      />
    </div>
  );
});

export default News;
